<template>
  <div ref="appContent" class="app-content">
    <el-card>
      <div class="mod-trade__agreement}">
        <el-form
            :inline="true"
            :model="dataForm"
            @keyup.enter.native="getDataList()"
            ref="queryForm"
            class="query-form"
        >
          <el-form-item label="外销合同编号：">
            <order-drop v-model="dataForm.agreementCode" size="mini"></order-drop>
          </el-form-item>

          <el-form-item label="供应商：">
            <company
                v-model="dataForm.companyId"
                @change="reload"
                :clearable="true"
                size="mini"
            ></company>
          </el-form-item>
          <el-form-item label="收货仓库：">
            <storages
                v-model="dataForm.storageId"
                @change="reload"
                :clearable="true"
                :showBtn="false"
                size="mini"
            />
          </el-form-item>
          <el-form-item>
            <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                size="mini"
                @click="doSave()"
                icon="el-icon-plus"
                v-if="$hasPermission('trade:purchaseagreement:save')"
            >创建采购合同
            </el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
                type="warning"
                size="mini"
                @click="importPurchase()"
                icon="el-icon-upload2"
                v-if="$hasPermission('trade:purchaseagreement:save')"
            >导入采购合同
            </el-button
            >
          </el-form-item>
          <el-form-item>
            <el-upload
                :action="uploadConfig.url"
                :before-upload="beforeUpload"
                :on-success="successHandle"
                :show-file-list="false"
                :on-error="errorHandle"
                :multiple="true"
                :on-progress="progressHandler"
                :data="{table:'ma_agreement'}"
                accept="image/*"
            >
              <el-button type="primary" size="mini" icon="el-icon-upload2">凭证批量上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-table
            v-loading="dataListLoading"
            :data="dataList"
            border
            style="width: 100%"
            :max-height="maxTableHeight"
        >
          <el-table-column
              type="index"
              header-align="center"
              align="center"
              width="50"
              label="行号"
          ></el-table-column>
          <el-table-column
              prop="orderCode"
              label="外销合同编号"
              header-align="center"
              align="center"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="totalPrice"
              label="总金额"
              header-align="center"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="companyName"
              label="供应商"
              header-align="center"
              align="center"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              label="收货方"
              header-align="center"
              align="center"
              prop="storageName"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="制单人"
              header-align="center"
              align="center"
              prop="creatorName"
          >
          </el-table-column>
          <el-table-column
              label="制单日期"
              header-align="center"
              align="center"
              prop="createDate"
          >
          </el-table-column>
          <el-table-column
              :label="$t('handle')"
              header-align="center"
              align="center"
              width="220"
              fixed="right"
          >
            <template slot-scope="scope">
              <div class="flex flex-wrap justify-center">
                <el-button
                    type="text"
                    @click="doSave(scope.row)"
                    icon="el-icon-edit-outline"
                    v-if="$hasPermission('trade:purchaseagreement:update')&&scope.row.status == 10"
                >修改
                </el-button
                >
                <el-button
                    icon="el-icon-close"
                    type="text"
                    @click="deleteHandle(scope.row.id)"
                    v-if="$hasPermission('trade:purchaseagreement:delete')&&scope.row.status == 10"
                >{{ $t('delete') }}
                </el-button
                >
                <el-button
                    type="text"
                    @click="checkIn(scope.row)"
                    icon="el-icon-folder-add"
                >收货入库
                </el-button
                >
                <el-button
                    type="text"
                    @click="showExportDialog(scope.row)"
                    icon="el-icon-folder-add"
                    v-if="$hasPermission('trade:purchasea:export')"
                >下载合同
                </el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
        >
        </el-pagination>
      </div>
    </el-card>
    <common-upload
        ref="uploader"
        @success="uploadSuccessHandler"
        uploadUrl="/trade/purchase/import/check/in"
        templateUrl="/static/template/采购账单明细导入模板.xlsx"
        title="采购账单明细导入"
    ></common-upload>
    <common-upload
        ref="purchaseUploader"
        @success="purchaseUploadSuccessHandler"
        uploadUrl="/trade/purchase/import"
        templateUrl="/static/template/采购合同批量导入模板.xlsx"
        title="采购合同批量导入"
    ></common-upload>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  components: {  },
  data () {
    return {
      dateArr: [],
      currentId: '',
      mixinViewModuleOptions: {
        getDataListURL: '/purchase/page',
        getDataListIsPage: true,
        exportURL: '/purchase/export',
        deleteURL: '/purchase',
        deleteIsBatch: true,
      },
      maxTableHeight: 100,
      dataForm: {
        storageId: '',
        companyId: '',
        agreementCode: '',
        isFuzzy:false
      },
      uploadConfig: {
        url: '',
      },
    }
  },
  created () {
    this.uploadConfig.url = `${
        window.SITE_CONFIG['apiURL']
    }/ys/file/upload?token=${Cookies.get('token')}`
  },
  activated () {
    this.$nextTick(() => {
      this.maxTableHeight =
          document.body.clientHeight -
          180
    })
  },
  watch: {},
  methods: {
    showExportDialog (row) {
      this.$refs.exportDialog.id = row.id
      this.$refs.exportDialog.init()
    },

    /*图片上传开始*/
    progressHandler (e) {
    },
    beforeUpload (file) {
      console.log('beforeUpload', file)
      return true
    },
    successHandle (res, file, fileList) {
      if (res.code != 0) {
        this.$message.error(res.msg)
      }
      console.log('successHandle', fileList, res)
    },
    errorHandle (err, file, fileList) {
      console.log('errorHandle', err)
    },
    //添加采购合同
    doSave (row) {
      let id=''
      if(row){
        id=row.id
      }
      this.$router.push(`/purchase/save?id=${id}`)
    },
    importPurchase () {
      this.$refs.purchaseUploader.init()
    },
    importCheckIn () {
      this.$refs.uploader.init()
    },
    uploadSuccessHandler (e) {
      this.reload()
    },
    purchaseUploadSuccessHandler (e) {
      this.reload()
    },
    showDetailDialog (row) {
      this.$refs.detailDialog.id = row.id
      this.$refs.detailDialog.init()
    },
    //采购入库
    checkIn (row) {
      this.$router.push(`/purchase-receive-index?purchaseId=${row.id}`)
    },
    addOrUpdateHandle (row) {
      let id = ''
      if (row) {
        id = row.id
      }
      this.$router.push(`/trade/purchase/agreement/save?id=${id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
